import getURI from "../uriset";
import { AgentExecuteLogList } from "@src/pages";

export default {
  AGENTLOG: {
    link: getURI("AGENTLOG"),
    component: AgentExecuteLogList,
  },
};
